import { useRef } from "react";
import { setSelectedDomain } from "../../state/actions/domain";
import { setBotWaitLoader, setBotWaitLoaderWithShimmer, setButtonLoader, setSearchLoader } from "../../state/actions/loader";
import { fetchBotSubscriptions, setConnectionId } from "../../state/actions/user";
import { updateTimeLine } from "../../state/actions/chats";
import store from "../../state/configureStore";
import { getFromLocalStorage, saveInLocalStorage } from "../storage/LocalStorage";
import { processMessageQueue } from "./messagesMiddleware";
import webSocketApiService from "./wsApiServices";
import { DOMAIN_RECEIVED } from "../../state/constants";
import { getReconnectCount, SOCKET } from "./initWebSocket";
import { formatMessageData } from "../../components/common/GetParsedMessage";
import {doActionBasedOnContentType} from "../../utils/general";
// All WebSocket method handlers live here
export const methodHandlers = {
  GetUserDomains: async (msg) => {
    console.log("%c Domains list ", "color: green;", msg.payload?.domains);
    const domainList = msg.payload?.domains

    if (domainList) {
      store.dispatch({
        type: DOMAIN_RECEIVED,
        payload: { domains: domainList },
      });
    }
    const lastLoggedInDomain = domainList.find(domain => domain.lastLoggedIn === true);
    console.log("%c Last Login Domain : ", "color: green;", lastLoggedInDomain);

    if (lastLoggedInDomain) {
      store.dispatch(setSelectedDomain(lastLoggedInDomain));

    }
    else {
      console.warn("No last logged-in domain found");
      store.dispatch(setBotWaitLoader(false));
    }
  },

  GetBotSubscriptionsInfo: (msg) => {
    console.log("GetBotSubscriptionsInfo", msg);

  },
  GetCatalog: (msg) => {
    // console.log("GetCatalog", msg.payload);
  },
  GetFavouriteConversations: (msg) => {
    // console.log("GetFavouriteConversations", msg.payload);
  },
  UploadFile: (msg) => {
    console.log("FILE UPLOAD STATUS:", msg.payload);
  },
  UpdateLastLoggedInDomain: (msg) => {
    console.log("UpdateLastLoggedInDomain", msg.payload);
  },

  Update: (msg) => {
    console.log("TIMELINE UPDATE:", msg.payload);
  },

  Status: (msg) => {
    console.log("QUEUE STATUS:", msg.payload);
  },
  deliverQueueMessages: (msg) => {
    console.log('deliverQueueMessages==> ', msg.payload)
    const data = msg.payload;
    
    const state = store.getState();
    const timeLine = state.chats.timeLine;
    const selectedConversation = state.chats.selectedConversation;
    const currentUserId = state.user?.user?.userId;
    const conversationId = data.conversation;

    const convIndex = timeLine.findIndex(c => c.conversationId === conversationId);
    doActionBasedOnContentType(data);
 
    if (convIndex !== -1) {
      const conv = { ...timeLine[convIndex] };
      const formattedMessage = formatMessageData(data);
      conv.lastMessage = formattedMessage;
      conv.contentType = formattedMessage.contentType;
      conv.createdOn = formattedMessage.createdOn;
      conv.modifiedOn = formattedMessage.createdOn;

      let newTimeLine = [...timeLine];
      if (!selectedConversation || selectedConversation.conversationId !== conversationId) {
        if (data.createdBy !== currentUserId) {
          // Check if this message already exists in timeline to avoid duplicate counting
          const existingConv = timeLine.find(c => c.conversationId === conversationId);
          const messageExists = existingConv && existingConv.modifiedOn === formattedMessage.createdOn;
          
          if (!messageExists) {
          conv.unreadCount = (conv.unreadCount || 0) + 1;
        }
        }
        newTimeLine.splice(convIndex, 1);
        newTimeLine.unshift(conv);
      } else {
        newTimeLine[convIndex] = conv;
      }
      store.dispatch(updateTimeLine(newTimeLine));
    }
  },
    deliverLargeQueueMessages: (msg) => {
    // Process the reassembled large message
    const { details, contentType, createdOn, createdBy, messageId } = msg.payload;
    const messageObj = details?.[0];
    if (messageObj && messageObj.messageType && messageObj.messageType === "Runmode") return;

    const options = { createdBy };

    messageQueue.current.push({
      messageObj: {
        messageId,
        messageType: contentType?.toString() || msg.payload.contentType?.toString(),
        createdBy,
        options,
        msg: messageObj?.msg || messageObj?.message || msg.payload
      },
      createdOn: createdOn || msg.payload.createdOn
    });

    console.log("Large message added to queue, queue length: ", messageQueue.current.length);
    setTimeout(() => processMessageQueue({ messageQueue }), 300);
  },
  GetWSConnectionId: async (msg) => {
    console.log('GetWSConnectionId==> ', msg.payload)
    const reconnectCount = getReconnectCount();
    console.log(
      `%cSOCKET: ${reconnectCount}, reconnect attempt...%c`,
      'color:green'
    );
    if (msg.payload && msg.payload.connectionId) {
      localStorage.setItem('connectionId', msg.payload.connectionId);
      store.dispatch(setConnectionId(msg.payload.connectionId));
      if(reconnectCount==0){
      await webSocketApiService.GetUserDomains()
      }
    }
  },
  Execute: (msg) => {
    console.log("EXECUTE:", msg.payload);
  },
  Ping: (msg) => {
    console.log("PING:", msg.payload);
  },
  //Contacts
  GetContacts: (msg) => {
    // console.log("GET CONTACTS:", msg.payload);
  },
  Find : (msg) => {
    // console.log("FIND CONTACTS:", msg.payload);
  },
  Add : (msg) => {
    // console.log("ADD CONTACTS:", msg.payload);
  },
  Remove : (msg) => {
    // console.log("REMOVE CONTACTS:", msg.payload);
  },
  Update : (msg) => {
    // console.log("UPDATE CONTACTS:", msg.payload);
  },
  Invite : (msg) => {
    // console.log("INVITE CONTACTS:", msg.payload);
  },
  Accept : (msg) => {
    // console.log("ACCEPT CONTACTS:", msg.payload);
  },
  Ignore : (msg) => {
    // console.log("IGNORE CONTACTS:", msg.payload);
  },
  GetCallHistoryForContact  : (msg) => {
    // console.log("GET CALL HISTORY FOR CONTACT:", msg.payload);
  },
  GetTimeline : (msg) => {
    // console.log("GET TIMELINE:", msg.payload);
  },
  // Group 
  Create:(msg) => {
    // console.log("CREATE GROUP:", msg.payload);
  },
  AddParticipants:(msg) => {
    // console.log("ADD PARTICIPANTS:", msg.payload);
  },
  GetSubscribed:(msg) => {
    // console.log("GET SUBSCRIBED GROUPS:", msg.payload);
  },
  GetUnsubscribed:(msg) => {
    // console.log("GET UNSUBSCRIBED GROUPS:", msg.payload);
  },
  GetParticipants:(msg) => {
    // console.log("GET PARTICIPANTS:", msg.payload);
  },
  Edit:(msg) => {
    // console.log("EDIT GROUP:", msg.payload);
  },
  UpdateParticipants:(msg) => {
    // console.log("UPDATE PARTICIPANTS:", msg.payload);
  },
  DeleteChannel:(msg) => {
    // console.log("DELETE GROUP:", msg.payload);
  },
  UpdateChannelAdmins:(msg) => {},
  ChangeOwner:(msg) => {},
  SubscribeBot:(msg) => {
    // console.log("SUBSCRIBE BOT:", msg.payload);
  },
  GetSignedUrlsForUpload:(msg) => {
    // console.log("GET SIGNED URLS FOR UPLOAD:", msg.payload);
  },
  CreateThumbnailForFile:(msg) => {

  },
  UpdateFavourites:(msg) => {
    // console.log("UPDATE FAVOURITES:", msg.payload);
  },
  UpdateUserProfile:(msg) => {
    // console.log("UPDATE USER PROFILE:", msg.payload);
  },
  getShipDetails:(msg) => {

  },
  GetLevel3Ranks:(msg) => {},
  DeleteUser:(msg) => {},
  SubscribeDomain:(msg) => {
    
  },
  ConfirmPayment:(msg) => {},
  InitiatePayment:(msg) => {},
  GetMongoDashboardData:(msg) => {},
  GetPaginatedCallHistory:(msg) => {},
  SendVoipPushNotification:(msg) => {},
  SetUserAvailableForCall:(msg) => {},
  CreateThumbnailForFile:(msg) => {},
};

// Store for assembling chunks - following AWS chunking pattern
const inFlightRequests = new Map();

const reassembleByRequest = (rawMessage) => {
  const msg = typeof rawMessage === 'string' ? JSON.parse(rawMessage) : rawMessage;

  // Non-chunked message - return as-is
  if (msg.method !== 'deliverLargeQueueMessages') {
    return msg;
  }

  const { requestId, _wsMeta } = msg;
  const { index, total } = _wsMeta;

  if (!inFlightRequests.has(requestId)) {
    inFlightRequests.set(requestId, {
      meta: msg,
      total,
      chunks: new Array(total)
    });
  }

  const entry = inFlightRequests.get(requestId);

  try {
    //  Browser-safe base64 decode
    const binary = atob(msg.payload);
    const len = binary.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binary.charCodeAt(i);
    }
    entry.chunks[index] = bytes;
  } catch (error) {
    console.error('Failed to decode chunk:', error);
    return null;
  }

  // SAFE completeness check
  for (let i = 0; i < entry.total; i++) {
    if (!(entry.chunks[i] instanceof Uint8Array)) {
      return null;
    }
  }

  // Reassemble
  const fullLength = entry.chunks.reduce((sum, c) => sum + c.length, 0);
  const fullBuffer = new Uint8Array(fullLength);

  let offset = 0;
  for (const chunk of entry.chunks) {
    fullBuffer.set(chunk, offset);
    offset += chunk.length;
  }

  const reconstructedPayload = JSON.parse(
    new TextDecoder('utf-8').decode(fullBuffer)
  );

  // Cleanup
  inFlightRequests.delete(requestId);

  // Return reconstructed message in original format
  return {
    service: entry.meta.service,
    method: entry.meta.method,
    requestId: entry.meta.requestId,
    timestamp: entry.meta.timestamp,
    error: entry.meta.error,
    payload: reconstructedPayload
  };
};

const messageQueue = {
  current: [],
}
export function handlePushMessage(msg) {

  console.log("%c[WS PUSH MESSAGE]", "color: orange;", msg);
  // Try to reassemble chunks first
  const reassembledMsg = reassembleByRequest(msg);

  // If null, chunks are still being collected
  if (!reassembledMsg) {
    console.log('Chunks still being collected, waiting for more...');
    return;
  }

  // Use reassembled message or original message
  const finalMsg = reassembledMsg;
  const selectedBotDetails = store.getState().domain.selectedBotDetails;
  const { method, payload: data } = finalMsg;

  // Dynamic method lookup
  const handler = methodHandlers[method];

  if (!handler) {
    // fallback log so no message goes unprocessed
    console.warn(`No handler for method "${method}"`, finalMsg);
    return;
  }
  console.log("COMPLETE MESSAGE RECEIVED FROM WESOCKET ==> ", data)
  console.log("COMPLETE METHOD RECEIVED FROM WESOCKET ==> ", method)
  if (method == "deliverQueueMessages" || method == "deliverLargeQueueMessages") {
    const { details, contentType, createdOn, createdBy, messageId } = data;
    const messageObj = details?.[0];
    if (messageObj.messageType && messageObj.messageType === "Runmode") return;

    const options = { createdBy };

    messageQueue.current.push({
      messageObj: {
        messageId,
        messageType: contentType.toString(),
        createdBy,
        options,
        msg: messageObj.message
      },
      createdOn
    });

  }
  if (data?.bot === selectedBotDetails?.botId && (method == "deliverQueueMessages" || method == "deliverLargeQueueMessages")) {
    // Dispatch all loaders off after 300ms
    setTimeout(() => {
      store.dispatch(setBotWaitLoader(false));
      store.dispatch(setButtonLoader(false));
      store.dispatch(setSearchLoader(false));
      store.dispatch(setBotWaitLoaderWithShimmer(false));
    }, 600);

    // Push message into the queue
    messageQueue.current.push({
      messageObj: data,
      createdOn: data.createdOn,
    });
  }
  setTimeout(() => {
    processMessageQueue({ messageQueue });
  }, 300)

  try {
    handler(msg); // safely call handler
  } catch (err) {
    console.error(`Error in handler for method "${method}"`, err);
  }
}
